import { c as _c } from "react/compiler-runtime";
import { Button } from '@chakra-ui/react';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ScoStoredFile } from '@src/graphql-types';
import React from 'react';
import { LuPaperclip } from 'react-icons/lu';
export type RequestProfileAttachmentButtonProps = {
  storedFile: Partial<ScoStoredFile>;
};
export const RequestProfileAttachmentButton: React.FC<RequestProfileAttachmentButtonProps> = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LuPaperclip />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.storedFile.fullUrl || $[2] !== props.storedFile.title) {
    t1 = <Button asChild={true} variant="outline"><NextLink href={props.storedFile.fullUrl} target="_blank">{t0}{props.storedFile.title}</NextLink></Button>;
    $[1] = props.storedFile.fullUrl;
    $[2] = props.storedFile.title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};